import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { localGet } from '@/config/storage'
import { ElMessage } from 'element-plus'
import store from '@/store'

const routes : Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'index',
		redirect: '/doorPlate',
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue'),
		meta: {
			title: '登录',
			module: 'login',
			showLeftMenu: false,
			showNav: false,
		}
	},
	{
	    name: 'street',
	    path: '/street',
	    component: () => import('@/views/street/Street.vue'),
	    meta: {
	        title: '街道管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'street'
	    }
	},
	{
	    name: 'user',
	    path: '/user',
	    component: () => import('@/views/user/User.vue'),
	    meta: {
	        title: '用户管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'log'
	    }
	},
	{
	    name: 'doorPlate',
	    path: '/doorPlate',
	    component: () => import('@/views/doorPlate/DoorPlate.vue'),
	    meta: {
	        title: '门牌管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'doorPlate'
	    }
	},
	{
	    name: 'resident',
	    path: '/resident',
	    component: () => import('@/views/resident/Resident.vue'),
	    meta: {
	        title: '居民管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'resident'
	    }
	},
	{
	    name: 'community',
	    path: '/community',
	    component: () => import('@/views/community/Community.vue'),
	    meta: {
	        title: '网格管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'community'
	    }
	},
	{
	    name: 'role',
	    path: '/role',
	    component: () => import('@/views/role/Role.vue'),
	    meta: {
	        title: '角色管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'role'
	    }
	},
	{
	    name: 'platform',
	    path: '/platform',
	    component: () => import('@/views/platform/Platform.vue'),
	    meta: {
	        title: '关于平台',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'platform'
	    }
	},
	{
	    name: 'policeDistrict',
	    path: '/policeDistrict',
	    component: () => import('@/views/policeDistrict/PoliceDistrict.vue'),
	    meta: {
	        title: '警区管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'policeDistrict'
	    }
	},
	{
	    name: 'services',
	    path: '/services',
	    component: () => import('@/views/services/Services.vue'),
	    meta: {
	        title: '便民服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'services'
	    }
	},
	{
	    name: 'specialPersonnel',
	    path: '/specialPersonnel',
	    component: () => import('@/views/specialPersonnel/SpecialPersonnel.vue'),
	    meta: {
	        title: '特殊人员管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'specialPersonnel'
	    }
	},
	{
	    name: 'popup',
	    path: '/popup',
	    component: () => import('@/views/popup/Popup.vue'),
	    meta: {
	        title: '弹窗管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'popup'
	    }
	},
	{
	    name: 'lifeHacks',
	    path: '/lifeHacks',
	    component: () => import('@/views/lifeHacks/LifeHacks.vue'),
	    meta: {
	        title: '生活小技巧',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'lifeHacks'
	    }
	},
	{
	    name: 'convenienceServices',
	    path: '/convenienceServices',
	    component: () => import('@/views/householdRepair/householdRepair.vue'),
	    meta: {
	        title: '便民服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
			needToken: true,
	        module: 'convenienceServices'
	    }
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach((to, _, next) => {
	const token = localGet('token')
	if(token){
		if (to.meta.title == '登录') {
			next('/')
		} else {
			next()
		}
	}else{
		if (to.meta.needToken) {
			ElMessage.error('请先登录')
			next('/login')
		} else {
			next()
		}
	}
})
router.afterEach(to => {
	let title = store.state?.publicOptions.platformInfo.systemName
	if(to.meta.title){
		title = String(to.meta.title)
	}
	document.title = title
})

export default router